import { render, staticRenderFns } from "./crossDoubt.vue?vue&type=template&id=09653316&scoped=true&"
import script from "./crossDoubt.vue?vue&type=script&lang=js&"
export * from "./crossDoubt.vue?vue&type=script&lang=js&"
import style0 from "./crossDoubt.vue?vue&type=style&index=0&id=09653316&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09653316",
  null
  
)

export default component.exports